module.exports = __webpack_public_path__ + "static/media/sustained_riser_white.b0998269.svg";